// extracted by mini-css-extract-plugin
export var carrierTab = "_4q-0";
export var carrierTabActive = "_4q-1 _4q-0";
export var carrierTabInactive = "_4q-2 _4q-0";
export var carrierTabLabel = "_4q-3";
export var carrierTabLabelActive = "_4q-4 _4q-3";
export var carrierTabLabelInactive = "_4q-5 _4q-3";
export var carrierTabPercentage = "_4q-6";
export var carrierTabPercentageActive = "_4q-7 _4q-6";
export var carrierTabPercentageInactive = "_4q-8 _4q-6";
export var carrierTabWinnable = "_4q-9";
export var carrierTabWinnableActive = "_4q-a _4q-9";
export var carrierTabWinnableInactive = "_4q-b _4q-9";
export var comparisonContainer = "_4q-d";
export var missingRateButton = "_4q-n";
export var missingRateButtonActive = "_4q-o _4q-n";
export var missingRateButtonInactive = "_4q-p _4q-n";
export var missingRateButtonLabel = "_4q-q";
export var missingRateButtonLabelActive = "_4q-r _4q-q";
export var missingRateButtonLabelInactive = "_4q-s _4q-q";
export var sidebar = "_4q-c";
export var strategyButton = "_4q-e";
export var strategyButtonActive = "_4q-f _4q-e";
export var strategyButtonDescription = "_4q-k";
export var strategyButtonDescriptionActive = "_4q-l _4q-k";
export var strategyButtonDescriptionInactive = "_4q-m _4q-k";
export var strategyButtonInactive = "_4q-g _4q-e";
export var strategyButtonLabel = "_4q-h";
export var strategyButtonLabelActive = "_4q-i _4q-h";
export var strategyButtonLabelInactive = "_4q-j _4q-h";
export var unitToggleButton = "_4q-t";
export var unitToggleButtonActive = "_4q-u _4q-t";
export var unitToggleButtonInactive = "_4q-v _4q-t";
export var unitToggleButtonLabel = "_4q-w";
export var unitToggleButtonLabelActive = "_4q-x _4q-w";
export var unitToggleButtonLabelInactive = "_4q-y _4q-w";